import React from 'react'
import './index.scss'
import deleteIcon from '../../assets/images/ic_home_delete.png'

const SearchHistory = props => {
  const { left, history, clearHistory, clickHistory, hotWords } = props
    return (
        <div className={`searchHistoryContent ${left ? 'left' : ''}`}>
            <div className="titleContent">
                <div className="leftText">历史搜索</div>
                <img
                    className="rightIcon"
                    src={deleteIcon}
                    onClick={clearHistory}
                ></img>
            </div>
            <div className="historyItemContent">
                {history.map((item, index) => {
                    return (
                      <div className="historyItem" key={`history${index}`} onClick={() => { clickHistory(item)}}>
                            {item}
                        </div>
                    )
                })}
            </div>

            <div className="titleContent hotTitleContent">
                <div className="leftText">热门搜索</div>
            </div>
            <div className="historyItemContent">
                {hotWords.map((item, index) => {
                    return (
                      <div className="historyItem" key={`history${index}`} onClick={() => { clickHistory(item)}}>
                            {item}
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default SearchHistory
